import { EditTwoTone } from '@ant-design/icons';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib';

export const EditAction = ({ title = 'Edit', disabled, onClick }: ButtonProps) => (
  <Button
    type='text'
    size='small'
    onClick={onClick}
    disabled={disabled}
    className='mr-1'
    icon={(
      <EditTwoTone
        title={title}
        twoToneColor={disabled ? '#bfbfbf' : ''}
      />
    )}
  />
);
